import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newPorcentajeIvaServicesSchema } from '@/shared';
import { useCreatePorcentajeIvaBienes, useUpdatePorcentajeIvaBienes } from '@/shared/actions/erp';
import {
  CustomNumberTextField,
  CustomTextField,
  SingleFormBoxScene,
  SwitchComponenteForm,
} from '@/shared/components/ui';
import { PORCENTAJEIVABIENES } from '@/shared/interfaces';
import { Grid, InputAdornment } from '@mui/material';

const returnUrlRbIVA = '/parametrizacion/porcentajes-ret-iva-bienes';

export interface SavePorcentajeIvaBienesInterface {
  titlePage: string;
  editPorcentajeIvaBienes?: PORCENTAJEIVABIENES;
}

type SaveFormData = {
  codigo: string;
  porcentaje: number;
  estado: boolean;
};

const SavePorcentajeIvaRetBienes: React.FC<SavePorcentajeIvaBienesInterface> = ({ titlePage, editPorcentajeIvaBienes }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createPorcentajeIvaRetBienesMutation = useCreatePorcentajeIvaBienes({ navigate, returnUrl: returnUrlRbIVA });
  const updatePorcentajeIvaRetBienesMutation = useUpdatePorcentajeIvaBienes({ navigate, returnUrl: returnUrlRbIVA });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newPorcentajeIvaServicesSchema),
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editPorcentajeIvaBienes?.id_porcentaje_ret_iva_bienes) {
      return updatePorcentajeIvaRetBienesMutation.mutate({
        id: editPorcentajeIvaBienes.id_porcentaje_ret_iva_bienes,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createPorcentajeIvaRetBienesMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editPorcentajeIvaBienes) {
      setShrink(true);
      reset({
        ...editPorcentajeIvaBienes,
      } as any);
    }
  }, [editPorcentajeIvaBienes]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlRbIVA);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Codigo"
        name='codigo'
        control={form.control}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      />

      <CustomNumberTextField
        label="Porcentaje"
        name={'porcentaje'}
        ///register={register('porcentaje')}
        error={errors.porcentaje}
        helperText={errors.porcentaje?.message}
        shrink={shrink}
        min={0}
        max={100}
        control={form.control}
        startAdornment={<InputAdornment position="start">%</InputAdornment>}
        defaultValue={form.getValues().porcentaje || ''}

      />

      <Grid container item >
        <SwitchComponenteForm
          control={control}
          defaultValue={form.getValues().estado || true}
          label={"Estado"}
          name="estado"
        />
      </Grid>
    </SingleFormBoxScene>
  );
};

export default SavePorcentajeIvaRetBienes;
